import client from './client'
import { WeChatAuth, WeChatInfo } from '@/types'

export const login = (data: { account: string; password: string; kind: 1 | 2; token: string }) => {
  return client<{ id: string }>({
    method: 'POST',
    url: 'user/signin',
    data,
  })
}

export function logout() {
  return client({
    method: 'POST',
    url: 'user/signout',
  })
}

export const wechatLogin = (params: WeChatAuth) => {
  return client<unknown>({
    method: 'GET',
    url: 'user/auth',
    params,
  })
}

export const getWechatInfo = (
  type: 'web' | 'oa',
  promotion?: string,
  share?: string,
  redirect?: string
) => {
  return client<WeChatInfo>({
    method: 'GET',
    baseURL: '/api',
    url: 'users/auth/wechat/info',
    params: { type, promotion, share, redirect },
  })
}

export const getUserOAStatus = () => {
  return client<{ is_follow: boolean }>({
    method: 'GET',
    url: 'user/follow/oa',
  })
}
